module.exports = __webpack_public_path__ + "static/media/striped_bar.8affcf28.svg";